import { createMuiTheme } from "@material-ui/core/styles"

export default function createSnapguestTheme (color: string | null) {
    if (color === null) {
        color = "d32f2f"
    }
    return createMuiTheme({
        palette: {
            primary: {
                main: "#" + color
            },
            secondary: {
                main: "#777777",
                dark: "#424242"
            }
        },
        overrides: {
            MuiButton: {
                root: {
                    borderRadius: "40px",
                    color: "white"
                },
                containedSecondary: {
                    color: "white"
                }
            },
            MuiTableHead: {
                root: {
                    backgroundColor: "#eeeeee"
                }
            },
            MuiTableCell: {
                root: {
                    borderBottom: "none",
                    paddingLeft: "3px",
                    paddingRight: "3px"
                },
                head: {
                    fontWeight: "normal"
                },
                footer: {
                    color: "black",
                    paddingTop: "6px",
                    paddingBottom: "6px",
                    fontSize: "0.875rem"
                }
            },
            MuiTableFooter: {
                root: {
                    borderTop: "1px solid #cccccc"
                }
            },
            MuiPaper: {
                rounded: {
                    borderRadius: "15px"
                }
            }
        }
    })
}
